module.exports = __webpack_public_path__ + "static/icon-big-doubt.235c43f0.svg";